import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);


/* eslint-disable global-require */
const router = new Router({
  routes: [
    {
      path: '/about/',
      name: 'about',
      component: require('./pages/About').default,
      children: [
        {
          path: 'personal/',
          name: 'about.personal',
          component: require('./pages/about/Personal').default,
        },
        {
          path: 'super/',
          name: 'about.super',
          component: require('./pages/about/Super').default,
        },
        {
          path: 'retirement/',
          name: 'about.retirement',
          component: require('./pages/about/Retirement').default,
        },
        {
          path: 'all/',
          name: 'about.all',
          hideInNav: true,
          component: require('./pages/about/All').default,
        },
      ],
    },
    {
      path: '/results/',
      name: 'results',
      component: require('./pages/Results').default,
      children: [
        {
          path: 'contributions/',
          name: 'results.contributions',
          component: require('./pages/results/Contributions').default,
        },
        {
          path: 'investment-mix/',
          name: 'results.investmentMix',
          component: require('./pages/results/InvestmentMix').default,
        },
        {
          path: 'career-break/',
          name: 'results.careerBreak',
          component: require('./pages/results/CareerBreak').default,
        },
        {
          path: 'retirement/',
          name: 'results.retirement',
          component: require('./pages/results/RetirementTarget').default,
        },
        {
          path: 'age-pension/',
          name: 'results.agePension',
          component: require('./pages/results/AgePension').default,
        },
        {
          path: 'personal/',
          name: 'results.personal',
          component: require('./pages/results/Personal.vue').default,
        },
        {
          path: 'super/',
          name: 'results.super',
          component: require('./pages/results/Super').default,
        },
        {
          path: 'assumptions/',
          name: 'results.assumptions',
          component: require('./pages/results/Assumptions').default,
        },
      ],
    },
    // {
    //   path: '/next-steps/',
    //   name: 'next-steps',
    //   component: require('./pages/NextSteps').default,
    // },
    {
      path: '/print/',
      name: 'print',
      component: require('./pages/Print').default,
    },
    // Redirects
    {
      path: '*',
      redirect: '/about/personal/',
    },
  ],
});
/* eslint-enable global-require */

// Ensure parent routes redirect to correct places
router.beforeEach((to, from, next) => {
  if (to.name === 'about') {
    router.replace({ name: 'about.personal' });
  } else if (to.name === 'results') {
    router.replace({ name: 'results.contributions' });
  } else {
    next();
  }
});

// router.afterEach((to) => {
// window.ga('send', 'pageview', to.path);
// });

// Ensure the modellers starts at the welcome screen
router.replace({ name: 'about.personal' });

export default router;
